import { render, staticRenderFns } from "./LottieComp.vue?vue&type=template&id=4f067c86&"
import script from "./LottieComp.vue?vue&type=script&lang=js&"
export * from "./LottieComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports